import React, { Fragment } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { connect } from "react-redux";
import "./analyticsHome.css";
import "chart.js";
import { analyticsGet } from "../../../actions/analytics";
import * as moment from "moment";
import AnalyticsFilter from "../analytics-filter/analyticsFilter";
import AnalyticsNavbar from "../navbar/analyticsNavbar";
import PieChart from "../charts/pieChart";
import BarChart from "../charts/barChart";
import { ListOfAnalytics } from "../../utils/constants.";
import LineChart from "../charts/lineChart";

class AnalyticsHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAnalytics: ListOfAnalytics[0]["id"], // Track selected analytics option
      activeDataset: [],
      startDate: moment().subtract(365, "days").format("yyyy-MM-DD"),
      endDate: moment().format("yyyy-MM-DD"),
    };
    autoBind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeDataset !== this.props.activeDataset) {
      this.setState({ activeDataset: this.props.activeDataset });
    }
  }

  componentDidMount() {
    this.props.analyticsGet(...this.getFormattedDate(), this.state.activeAnalytics);
  }

  getFormattedDate() {
    return [
      moment(this.state.startDate, "yyyy-MM-DD").format("DD-MM-yyyy"),
      moment(this.state.endDate, "yyyy-MM-DD").format("DD-MM-yyyy"),
    ];
  }

  handleAnalyticsClick = (obj) => {
    if (obj.id !== this.state.activeAnalytics) {
      this.setState({ activeAnalytics: obj.id, activeDataset: [] }); // Clear state, not props
      this.props.analyticsGet(...this.getFormattedDate(), obj.id); // Fetch data when clicked
    }
  };

  handleDateChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({
      ...this.state,
      [name]: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.analyticsGet(...this.getFormattedDate(), this.state.activeAnalytics);
  }

  getChart(chartType) {
    switch (chartType) {
      case "line":
        return <LineChart data={this.state.activeDataset}></LineChart>;
      case "bar":
        return <BarChart data={this.state.activeDataset} activeChartID={this.state.activeAnalytics}></BarChart>;
      case "pie":
        return <PieChart data={this.state.activeDataset}></PieChart>;
      default:
        return "";
    }
  }

  render() {
    const mapType = ListOfAnalytics.find((item) => item.id === this.state.activeAnalytics).mapType;
    return (
      <Fragment>
        <div className="analytics">
          <div className="analytics-content">
            <div className="row">
              <div className="col-2">
                <AnalyticsNavbar
                  activeAnalytics={this.state.activeAnalytics}
                  handleAnalyticsClick={this.handleAnalyticsClick}
                ></AnalyticsNavbar>
              </div>
              <div className="col-10">
                <div className="card" style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <div className="card-body">
                    <AnalyticsFilter
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      handleDateChange={this.handleDateChange}
                      handleSubmit={this.handleSubmit}
                    ></AnalyticsFilter>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">{this.getChart(mapType)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

AnalyticsHome.propTypes = {
  reviews: PropTypes.array,
};

function mapStateToProps(state, props) {
  return {
    activeDataset: state.analyticsCalls.analytics_data,
  };
}
export default connect(mapStateToProps, { analyticsGet })(AnalyticsHome);
